var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenGolden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 10.5417V13.625C15.4168 16.225 12.9918 18.3334 10.0002 18.3334C7.0085 18.3334 4.5835 16.225 4.5835 13.625V10.5417C4.5835 13.1417 7.0085 15 10.0002 15C12.9918 15 15.4168 13.1417 15.4168 10.5417Z",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 6.37502C15.4168 7.13336 15.2085 7.83335 14.8418 8.43335C13.9502 9.90002 12.1168 10.8334 10.0002 10.8334C7.8835 10.8334 6.05016 9.90002 5.1585 8.43335C4.79183 7.83335 4.5835 7.13336 4.5835 6.37502C4.5835 5.07502 5.19182 3.90002 6.16682 3.05002C7.15016 2.19169 8.50016 1.66669 10.0002 1.66669C11.5002 1.66669 12.8502 2.19169 13.8335 3.04169C14.8085 3.90002 15.4168 5.07502 15.4168 6.37502Z",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4168 6.37502V10.5417C15.4168 13.1417 12.9918 15 10.0002 15C7.0085 15 4.5835 13.1417 4.5835 10.5417V6.37502C4.5835 3.77502 7.0085 1.66669 10.0002 1.66669C11.5002 1.66669 12.8502 2.19169 13.8335 3.04169C14.8085 3.90002 15.4168 5.07502 15.4168 6.37502Z",
    stroke: "#F6B21A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenGolden);
export default __webpack_public_path__ + "static/media/token-golden.820b57b793da4f52407d7ea5a1bb7a0d.svg";
export { ForwardRef as ReactComponent };